import { Text, Icon, Box, HStack, Link } from '@chakra-ui/react';

import { IoStopwatchOutline } from 'react-icons/io5';

import { useTranslation } from 'react-i18next';

export type LeaderHeaderProps = {
  onOpen: () => void;
};

// 給團長顯示的揪團基本資料以及選擇是否取消揪團，在畫面下拉時會顯示fix在畫面最上面
export default function LeaderHeader({ onOpen }: LeaderHeaderProps) {
  const { t } = useTranslation();

  return (
    <Box borderColor="wsGray.400" borderBottomWidth="1px" bgColor="white" py={2} px={3}>
      <HStack justify="space-between" align="stretch">
        <HStack>
          <Icon as={IoStopwatchOutline} color="wsBlack" boxSize="1.25rem" />
          <Text fontSize="sm" color="wsBlack">
            {t('group.onGoing')}
          </Text>
        </HStack>
        <Link fontSize="xs" color="wsGray.500" textDecoration="none" onClick={onOpen}>
          {t('group.cancel')}
        </Link>
      </HStack>
    </Box>
  );
}
